export const LABELS_REPORT_BUILDER = {
    updateReport: 'Оновити звіт',
    equal: 'Рівний',
    notEqual: 'Не рівний',
    selectAccount: 'Оберіть Перевізник',
    lessThan: 'Менший',
    showConditionMessage: 'Тут звявиться нова умова',
    greaterThan: 'Більший',
    lessThanEqual: 'Менший або рівний',
    greaterThanEqual: 'Більший або рівний',
    deleteReport: 'Видалити звіт',
    existingReports: 'Існуючі звіти',
    newReport: 'Створити Новий звіт',
    sourceData: 'Джерело даних',
    rootTable: 'Основна таблиця',
    saveConditionsConfirmMessage: 'Ви впевнені що хочете зберегти умови?',
    displayNameColumn: 'Назва колонки',
    saveReportAsNew: 'Збергти як новий',
    saveReportSuccessMessage: 'Ви успішно зберегли звіт!',
    updateReportSuccessMessage: 'Ви успішно оновили звіт!',
    additionalTable: 'Додаткова таблиця',
    uniqColumnIdMessage: 'Назва колонки має бути унікальною',
    newParams: 'Новий параметр',
    menuAddColumn: 'Меню додавання колокни',
    menuUpdatedColumn: 'Меню оновлення колонки',
    updateColumn: 'Оновити колонку',
    sort: 'Сортування',
    addColumn: 'Додати колонку',
    report: 'Звіт',
    singleValue: 'Одне значення',
    multiValue: 'Декілька',
    typeReport: 'Тип звіту',
    saveColumnsConfirmMessage: 'Ви впевненеі що хочете зберегти колонку?',
    deleteColumnsConfirmMessage: 'Ви впевненеі що хочете видалити колонку?',
    closeColumnsConfirmMessage: 'Ви впевненеі що хочете закрити налаштування колонки без збереження?',
    closeExportStylesConfirmMessage: 'Ви впевненеі що хочете закрити налаштування експорту до PDF без збереження?',
    addCondition: 'Додати умову',
    condition: 'Умови',
    confirmMessageCloseConfirm: 'Ви впевнені що хочете закрити умову без збереження?',
    confirmMessageSaveSettingsConfirm: 'Ви впевнені що хочете зберегти налаштування?',
    deleteConfirmMessageConditions: 'Ви впевнені що хочете видалити умову?',
    updateCondition: 'Оновити умову',
    deleteReportSuccessMessage: 'Ви успішно видалили звіт!',
    columnNameData: 'Колонки з бази даних',
    messageConfirmCloseColumn: 'Ви впевнені що бажаєте закрити колонку?',
    messageAddColumnsForDisplay: 'Додайте колонки для відображення...',
    messageReportChangeSourceData: 'Ви впевнені що бажаєте змінити джерело даних? Це призведе до очищення колонок та налаштувань',
    messageReportChangeAdditionalData: 'Ви впевнені що бажаєте змінити додаткове джерело даних? Це призведе до очищення колонок та налаштувань',
    messageReportChangeAdditionalDataConditions: 'Ви впевнені що бажаєте змінити додаткове джерело даних? Це призведе до очищення налаштувань',
}